import React from "react";

// PageShell: adds top padding so nav doesn't overlap content,
// then renders children inside a stable background.
const PageShell = ({ children, dataTestId }) => {
  return (
    <main
      data-testid={dataTestId}
      className="relative min-h-[60vh] pt-32 md:pt-40 bg-[#050505]"
    >
      {children}
    </main>
  );
};

export default PageShell;
